import React__default from 'react';
import classNames from './../external_lib/classnames/index.js';
import { useTranslation } from 'react-i18next';
import Typography from '../Atoms/Typography.js';
import LazyImage from '../Atoms/LazyImage.js';

function HowItWorksThree(_a) {
    var classes = _a.classes, _b = _a.values, values = _b === void 0 ? [] : _b, title = _a.title, imageComponent = _a.imageComponent;
    var t = useTranslation().t;
    return (React__default.createElement("div", { className: classNames('how-it-works', classes) },
        React__default.createElement(Typography, { classes: 'how-it-works__heading', variant: 'displayText' }, title ? title : t('landingScreen.howItWorks')),
        React__default.createElement("div", { className: "how-it-works__cards" }, values === null || values === void 0 ? void 0 : values.map(function (value) { return (React__default.createElement("div", { title: value.description, className: "how-it-works__card" },
            React__default.createElement(LazyImage, { classes: "how-it-works__card__icon", src: value.icon, alt: value.label, imageComponent: imageComponent }),
            React__default.createElement(Typography, { classes: "how-it-works__card__title", variant: 'headingOne' }, value.label),
            React__default.createElement(Typography, { classes: "how-it-works__card__description", variant: 'bodyTextOne' }, value.description))); }))));
}

export { HowItWorksThree as default };
//# sourceMappingURL=HowItWorksThree.js.map
